import { render, staticRenderFns } from "./ChevronTopSolid.vue?vue&type=template&id=5b7ef872&"
import script from "./ChevronTopSolid.vue?vue&type=script&lang=ts&"
export * from "./ChevronTopSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports